import { PageHero } from "@/components/Section";
import DeliveryMap from "@/components/home/DeliveryMap";
import { Reveal, stagger, fadeUp } from "@/components/Reveal";
import { motion } from "framer-motion";
import { Truck, CalendarClock, MapPin, PackageCheck, BellRing, ShieldCheck } from "lucide-react";

const HIGHLIGHTS = [
  { icon: Truck, t: "Free Edmonton Delivery", d: "Free across Edmonton on qualifying wholesale orders." },
  { icon: MapPin, t: "Alberta-Wide Delivery", d: "Scheduled and route delivery to communities across Alberta." },
  { icon: CalendarClock, t: "Recurring Schedules", d: "Set delivery days that repeat around your operation." },
  { icon: PackageCheck, t: "Safe Handling", d: "Careful handling of food and restaurant supplies, dock to kitchen." },
  { icon: BellRing, t: "Order Status Updates", d: "Know when your order is prepared and on its way." },
  { icon: ShieldCheck, t: "Professional Team", d: "A trained delivery team that understands foodservice." },
];

export default function Delivery() {
  return (
    <>
      <PageHero
        chapter="Delivery"
        title="Delivery that works around your business"
        lead="Every restaurant has a different ordering schedule. Our team works with customers to create delivery days that fit their operations — free across Edmonton on qualifying orders, with Alberta-wide reach."
      />

      <section className="py-24 md:py-32 bg-white border-b border-forest/10">
        <div className="max-w-[1440px] mx-auto px-5 md:px-10">
          <motion.div variants={stagger} initial="hidden" whileInView="show" viewport={{ once: true }} className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {HIGHLIGHTS.map(({ icon: Icon, t, d }) => (
              <motion.div key={t} variants={fadeUp} className="rounded-3xl border border-forest/15 bg-cream p-7">
                <span className="grid place-items-center h-12 w-12 rounded-2xl bg-sage text-forest mb-4"><Icon className="h-5 w-5" /></span>
                <h3 className="font-display text-xl text-forest">{t}</h3>
                <p className="text-sm text-forest/70 mt-2 leading-relaxed">{d}</p>
              </motion.div>
            ))}
          </motion.div>
        </div>
      </section>

      <DeliveryMap />
    </>
  );
}
